import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../../auth/services/auth.service';
import { ProfileService, UserProfile } from '../../../dms/services/profile.service';

@Component({
  selector: 'app-vertical-header',
  templateUrl: './vertical-header.component.html',
  styleUrls: []
})

export class VerticalAppHeaderComponent implements OnInit, OnDestroy {
  public config: any = {};
  private subscriptions: Subscription[] = [];

  currentUser: UserProfile | null = null;
  userDisplayName = 'User';
  userProfilePhotoUrl: string | SafeUrl | null = null;
  hasUserPhoto = false;
  private photoObjectUrl: string | null = null;

  logout(): void {
    // this.authService.logout();
    this.authService.signOut(); // revoke on the server too
    this.router.navigate(['/auth/login']);
  }


  // This is for Notifications
  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Launch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  }

  public languages: any[] = [{
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  },
  {
    language: 'Español',
    code: 'es',
    icon: 'es'
  },
  {
    language: 'Français',
    code: 'fr',
    icon: 'fr'
  },
  {
    language: 'German',
    code: 'de',
    icon: 'de'
  }]



  constructor(
    public authService: AuthService,
    private profileService: ProfileService,
    private router: Router,
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.loadUserProfile();

    // Subscribe to profile changes (name, email, etc.)
    this.subscriptions.push(
      this.profileService.profile$.subscribe(profile => {
        if (profile) {
          this.currentUser = profile;
          this.userDisplayName = `${profile.firstName} ${profile.lastName}`;
        }
      })
    );

    // Subscribe to shared photo URL changes (from profile page upload/remove)
    this.subscriptions.push(
      this.profileService.profilePhotoUrl$.subscribe(url => {
        if (url) {
          this.userProfilePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          this.hasUserPhoto = true;
        } else {
          this.userProfilePhotoUrl = null;
          this.hasUserPhoto = false;
        }
      })
    );
  }

  private loadUserProfile(): void {
    const user = this.authService.getCurrentUser();
    if (user) {
      this.userDisplayName = `${user.firstName} ${user.lastName}`;
    }

    this.profileService.getMyProfile().subscribe(
      profile => {
        this.currentUser = profile;
        this.userDisplayName = `${profile.firstName} ${profile.lastName}`;
        this.loadProfilePhoto(profile);
      },
      error => console.error('Failed to load profile:', error)
    );
  }

  private loadProfilePhoto(profile: UserProfile): void {
    if (!profile?.id) { return; }
    this.profileService.getProfilePhotoBlobUrl(profile.id).subscribe(
      objectUrl => {
        if (this.photoObjectUrl) { URL.revokeObjectURL(this.photoObjectUrl); }
        this.photoObjectUrl = objectUrl;
        this.userProfilePhotoUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
        this.hasUserPhoto = true;
        this.profileService.setProfilePhotoUrl(objectUrl);
      },
      () => {
        this.hasUserPhoto = false;
        this.userProfilePhotoUrl = null;
        this.profileService.setProfilePhotoUrl(null);
      }
    );
  }

  goToProfile(): void {
    this.router.navigate(['/dms/profile']);
  }

  onImageError(): void {
    this.hasUserPhoto = false;
    this.userProfilePhotoUrl = null;
  }

  changeLanguage(lang: any) {
    this.translate.use(lang.code)
    this.selectedLanguage = lang;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.photoObjectUrl) { URL.revokeObjectURL(this.photoObjectUrl); }
  }
}
